module.exports = __webpack_public_path__ + "static/zag-983f46d62ee8f5df2ade4a3d6c20b885.jpg";